import Accordion from "react-bootstrap/Accordion";

function Accordions() {
  return (
    <Accordion>
      <Accordion.Item eventKey="0" data-aos="fade-up" data-aos-duration="1000">
        <Accordion.Header>1. Initiate a Deal</Accordion.Header>
        <Accordion.Body>
          <div className="row">
            <div className="col-lg-6">
              <ol>
                <li>
                  <b> Access the Platform:</b> Navigate to the Pharma Trades
                  website and connect your wallet.
                </li>
                <li>
                  <b> Initiate Deal:</b>
                  <ul>
                    <li>Click on "Create New Deal."</li>
                    <li>Enter the buyer's wallet address.</li>
                    <li>
                      Specify the tokens and amounts for both the seller and
                      buyer.
                    </li>
                    <li>Select Fee Payment Option:</li>
                    <li>Choose who will pay the initiation fee:</li>
                    <li>
                      <b>Seller Pays</b>
                    </li>
                    <li>
                      <b>Buyer Pays</b>
                    </li>
                    <li>
                      <b>Split Equally</b>
                    </li>
                    <li>(Optional) Set up a vesting schedule.</li>
                    <li>(Optional) Enter a referrer's address.</li>
                    <li>
                      {" "}
                      <b>Fee Payment:</b>
                    </li>
                    <li>
                      The platform will calculate{" "}
                      <b> 1% of the total trade value.</b>
                    </li>
                    <li>
                      <b> Depending on the selected fee payment option:</b>
                    </li>
                    <li>
                      <b>Seller Pays:</b>
                    </li>
                    <li>
                      The seller will need to approve the transfer of the
                      calculated amount in <b> $PHARMA tokens</b> to pay the
                      initiation fee.
                    </li>
                    <li>
                      {" "}
                      <b>Buyer Pays:</b>
                    </li>
                    <li>
                      The buyer will need to approve the transfer when they
                      participate in the deal.
                    </li>
                    <li>
                      {" "}
                      <b>Split Equally:</b>
                    </li>
                    <li>
                      Both parties will each pay{" "}
                      <b> half of the initiation fee </b> in <b>$PHARMA tokens.</b>
                    </li>
                    <li>Confirm and approve the transaction.</li>
                  </ul>
                </li>
              </ol>
            </div>
            <div className="col-lg-6">
              <img
                className="cases-w"
                src="/assets/images/InitiatingaDeal.svg"
                alt="InitiatingaDeal"
              />
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1" data-aos="fade-up" data-aos-duration="1100">
        <Accordion.Header>2. Depositing Tokens</Accordion.Header>
        <Accordion.Body>
          <div className="row">
            <div className="col-lg-6">
              <b>Seller Instructions</b>
              <ul>
                <li>
                  <b>Deposit Tokens:</b>
                </li>
                <li>Navigate to your deal in the "My Deals" section.</li>
                <li>Click on "Deposit Tokens."</li>
                <li>Approve the token transfer in your wallet.</li>
              </ul>
              <b>Buyer Instructions</b>
              <ul>
                <li>
                  <b> Deposit Payment:</b>
                </li>
                <li>
                  The buyer accesses the deal via the link provided or through
                  the platform.
                </li>
                <li>
                  <b>
                    If the buyer is responsible for the fee or splitting it:
                  </b>
                </li>
                <li>
                  <b>Fee Payment:</b>
                </li>
                <li>
                  The buyer will be prompted to approve the transfer of their
                  portion of the initiation fee in <b> $PHARMA tokens.</b>
                </li>
                <li>Confirm and approve the transaction.</li>
                <li>Click on "Deposit Payment."</li>
                <li>Approve the transaction in the wallet.</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <img
                className="cases-w"
                src="/assets/images/DepositingTokens.svg"
                alt="DepositingTokens"
              />
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2" data-aos="fade-up" data-aos-duration="1100">
        <Accordion.Header>3. Completing a Deal</Accordion.Header>
        <Accordion.Body>
          <div className="row">
            <div className="col-lg-6">
              <ul>
                <li>
                  <b>Conditions for Completion:</b>
                </li>
                <li>Both parties have deposited the required tokens.</li>
                <li>The deal has not expired.</li>
                <li>
                  <b>Complete Deal:</b>
                </li>
                <li>Either party can click on "Complete Deal."</li>
                <li>Confirm the transaction in your wallet.</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <img
                className="cases-w"
                src="/assets/images/CompletingaDeal.svg"
                alt="CompletingaDeal"
              />
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>

      <Accordion.Item eventKey="3" data-aos="fade-up" data-aos-duration="1100">
        <Accordion.Header>4. Claiming Vested Tokens</Accordion.Header>
        <Accordion.Body>
          <div className="row">
            <div className="col-lg-6">
              <ul>
                <li>
                  <b>Access Vesting Schedule:</b>
                </li>
                <li>Go to the "Vesting" section in your account.</li>
                <li>
                  <b>Claim Tokens:</b>
                </li>
                <li>If tokens have vested, click on "Claim Tokens."</li>
                <li>Approve the transaction in your wallet.</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <img
                className="cases-w"
                src="/assets/images/ClaimingVestedTokens.svg"
                alt="ClaimingVestedTokens"
              />
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="4" data-aos="fade-up" data-aos-duration="1100">
        <Accordion.Header>5. Canceling a Deal</Accordion.Header>
        <Accordion.Body>
          <div className="row">
            <div className="col-lg-6">
              <ul>
                <li>
                  <b>Before Completion:</b>
                </li>
                <li>Navigate to your deal.</li>
                <li>Click on "Cancel Deal."</li>
                <li>Confirm the cancellation.</li>
                <li>
                  <b>After Expiration:</b>
                </li>
                <li>
                  The deal will automatically cancel, and tokens can be
                  withdrawn.
                </li>
              </ul>
            </div>
            <div className="col-lg-6">
              <img
                className="cases-w"
                src="/assets/images/CancelingaDeal.svg"
                alt="CancelingaDeal"
              />
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5" data-aos="fade-up" data-aos-duration="1100">
        <Accordion.Header>6. Claiming Referral Rewards</Accordion.Header>
        <Accordion.Body>
          <div className="row">
            <div className="col-lg-6">
              <ul>
                <li>
                  <b>Check Eligibility:</b>
                </li>
                <li>Go to the "Referrals" section in your account.</li>
                <li>
                  <b>Claim Rewards:</b>
                </li>
                <li>If rewards are available, click on "Claim Rewards."</li>
                <li>
                  Referral rewards are paid in <b> $PHARMA </b>tokens.
                </li>
                <li>Approve the transaction in your wallet.</li>
              </ul>
            </div>
            <div className="col-lg-6">
              <img
                className="cases-w"
                src="/assets/images/Claiming.svg"
                alt="Claiming"
              />
            </div>
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default Accordions;
